import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";

import SesionView from "../Login/SesionView";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import Forward from "@material-ui/icons/Forward";
import HomeIcon from "@material-ui/icons/Home";
import Event from "@material-ui/icons/Event";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import Assessment from "@material-ui/icons/Assessment";
import LiveTv from "@material-ui/icons/LiveTv";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import DirectionsRunIcon from "@material-ui/icons/DirectionsRun";

import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles((theme) => ({
  link: {
    margin: theme.spacing(1),
    color: "#EF4123",
  },
}));

const SideMenuView = ({ atleteAccount, handleDrawerClose }) => {
  const classes = useStyles();

  let authorizedUsers;
  if (atleteAccount && atleteAccount.perfil === 1) {
    authorizedUsers = (
      <List>
        <ListItem button onClick={handleDrawerClose}>
          <ListItemIcon className={classes.link}>
            <VerifiedUser />
          </ListItemIcon>
          <Link to={`/usuario-autorizado/`}>
            <ListItemText
              className={classes.link}
              primary={"Usuarios Autorizados"}
            />
          </Link>
        </ListItem>
      </List>
    );
  }

  return (
    <div>
      <SesionView handleDrawerClose={handleDrawerClose} />
      <List>
        <ListItem button onClick={handleDrawerClose}>
          <ListItemIcon className={classes.link}>
            <Forward />
          </ListItemIcon>
          <Link to={`/proximos-eventos/`}>
            <ListItemText
              className={classes.link}
              primary={"Próximos Eventos"}
            />
          </Link>
        </ListItem>
        <ListItem button onClick={handleDrawerClose}>
          <ListItemIcon className={classes.link}>
            <Assessment />
          </ListItemIcon>
          <Link to={`/resultados/`}>
            <ListItemText className={classes.link} primary={"Resultados"} />
          </Link>
        </ListItem>
        <ListItem button onClick={handleDrawerClose}>
          <ListItemIcon className={classes.link}>
            <LiveTv />
          </ListItemIcon>
          <Link to={`/live/`}>
            <ListItemText className={classes.link} primary={"Eventos en Vivo"} />
          </Link>
        </ListItem>

        <ListItem button onClick={handleDrawerClose}>
          <ListItemIcon className={classes.link}>
            <EmojiEventsIcon />
          </ListItemIcon>
          <Link to={`/retos/`}>
            <ListItemText
              className={classes.link}
              primary={"Retos Virtuales"}
            />
          </Link>
        </ListItem>
        <ListItem button onClick={handleDrawerClose}>
          <ListItemIcon className={classes.link}>
            <Event />
          </ListItemIcon>
          <Link to={`/retos-organizador/`}>
            <ListItemText
              className={classes.link}
              primary={"Mis retos Organizados"}
            />
          </Link>
        </ListItem>
        <ListItem button onClick={handleDrawerClose}>
          <ListItemIcon className={classes.link}>
            <HomeIcon />
          </ListItemIcon>
          <Link to={`/`}>
            <ListItemText className={classes.link} primary={"Inicio"} />
          </Link>
        </ListItem>
        <ListItem button onClick={handleDrawerClose}>
          <ListItemIcon className={classes.link}>
            <DirectionsRunIcon />
          </ListItemIcon>
          <Link to={`/atletas/`}>
            <ListItemText className={classes.link} primary={"Mi perfil"} />
          </Link>
        </ListItem>

        {/* <ListItem button  onClick={handleDrawerClose}>
		  <ListItemIcon className={classes.link}><Event/></ListItemIcon>
			<Link to={`/mis-eventos/`}>
				<ListItemText className={classes.link} primary={"Mis Eventos"}/> 
			</Link>
		</ListItem> */}

        <Divider />

        <ListItem button onClick={handleDrawerClose}>
          <ListItemIcon className={classes.link}>
            <InboxIcon />
          </ListItemIcon>
          <Link to={`/servicios/`}>
            <ListItemText className={classes.link} primary={"Sobre Dashport"} />
          </Link>
        </ListItem>
      </List>
      <Divider />
      {authorizedUsers}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    atleteAccount: state.atlete.atleteAccount,
  };
};

const SideMenu = connect(mapStateToProps)(SideMenuView);

export default SideMenu;
